import type {TvmList} from '../../types'

export const PRODUCTION = {
  exp3: {host: 'exp3-matcher-srb-virt.taxi.yandex.net', name: 'exp3-matcher-srb-virt', id: 2065045},
  account: {name: 'delivery-frontend-account-virt', id: 2070212},
  auth: {name: 'delivery-frontend-auth-virt', id: 2069644},
  route: {name: 'delivery-frontend-route-virt', id: 2070132},
  tariffs: {name: 'delivery-frontend-tariffs-virt', id: 2070136},
} as const satisfies TvmList
